import Button, { ButtonProps } from "@mui/material/Button";

export type { ButtonProps };
export default Button;
